import { ActionReducerMap } from '@ngrx/store';

import * as fromQuickQuoteReducer from './quick-quote-feature/quick-quote-feature.reducer';

export interface ReplaceVehicleFeatureState {
  quickQuote: fromQuickQuoteReducer.QuickQuoteFeatureState;
  // TODO: quickquote - purchase quote state goes here
}

export const replaceVehicleFeatureReducers: ActionReducerMap<ReplaceVehicleFeatureState> = {
  quickQuote: fromQuickQuoteReducer.reducer
  // TODO: quickquote - purchase quote reducer goes here
};
